import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "../ui/dialog";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Textarea } from "../ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";

export const TYPE_LABEL = { standard: "Standard (routine)", normal: "Normal (feature / logic)", security: "Security-sensitive", emergency: "Emergency fix" };
const EMPTY = { title: "", description: "", change_type: "normal", risk: "low", rollback_plan: "", test_evidence: "" };

const Pick = ({ label, value, onChange, options, testId }) => (
  <div className="space-y-1"><Label>{label}</Label>
    <Select value={value} onValueChange={onChange}><SelectTrigger data-testid={testId}><SelectValue /></SelectTrigger>
      <SelectContent>{Object.entries(options).map(([k, v]) => <SelectItem key={k} value={k}>{v}</SelectItem>)}</SelectContent></Select>
  </div>
);

export function ChangeCreateDialog({ open, onOpenChange, onCreate }) {
  const [form, setForm] = useState(EMPTY);
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));
  const needsRollback = ["normal", "security"].includes(form.change_type);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle>Record a change</DialogTitle>
          <DialogDescription>A second person must approve it before release. Emergency fixes can be released first and approved within 2 working days.</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <div className="space-y-1"><Label>Title</Label><Input value={form.title} onChange={(e) => set("title", e.target.value)} data-testid="change-title-input" /></div>
          <div className="space-y-1"><Label>What is changing and why</Label><Textarea rows={3} value={form.description} onChange={(e) => set("description", e.target.value)} data-testid="change-description-input" /></div>
          <div className="grid grid-cols-2 gap-3">
            <Pick label="Type" value={form.change_type} onChange={(v) => set("change_type", v)} options={TYPE_LABEL} testId="change-type-select" />
            <Pick label="Risk" value={form.risk} onChange={(v) => set("risk", v)} options={{ low: "Low", medium: "Medium", high: "High" }} testId="change-risk-select" />
          </div>
          <div className="space-y-1"><Label>Rollback plan{needsRollback ? " (required)" : ""}</Label><Textarea rows={2} value={form.rollback_plan} onChange={(e) => set("rollback_plan", e.target.value)} data-testid="change-rollback-input" /></div>
          <div className="space-y-1"><Label>Test evidence</Label><Textarea rows={2} value={form.test_evidence} onChange={(e) => set("test_evidence", e.target.value)} placeholder="e.g. automated tests passed, test report link" data-testid="change-test-input" /></div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button disabled={form.title.trim().length < 3 || (needsRollback && !form.rollback_plan.trim())}
            onClick={async () => { if (await onCreate(form)) setForm(EMPTY); }} data-testid="change-create-submit">Submit for approval</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
